import type { ParamParseKey, PathMatch, PathPattern } from '@remix-run/router';
import { matchPath } from '@remix-run/router';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

function useMatch<ParamKey extends ParamParseKey<Path>, Path extends string>(
  pattern: PathPattern<Path> | Path
): PathMatch<ParamKey> | null {
  const pathname = usePathname() ?? '';

  return useMemo(() => matchPath(pattern, pathname), [pathname, pattern]);
}

export default useMatch;
